import React from 'react'
import { Field } from 'redux-form'

import FilterLozenge from '@cinch/oxd-components/filter-lozenge/src'
import { FILTER_TYPE } from '@cinch/oxd-components/listing-filters/src'
import { setToString } from '@cinch/oxd-utils/form/src'

interface FilterLozengeProps {
  labelPrefix?: string
  initialValue?: any
  onReset?: () => void
}

import * as styles from './filter-lozenge-group.module.css'

export const removeLozengeAndUpdateValue = (
  lozengeValue: any,
  values: any,
  onChange: any,
  initialValue?: any,
  onReset?: any,
) => {
  values.splice(values.indexOf(lozengeValue), 1)
  if (values.length) {
    onChange(values.join())
  } else {
    onReset ? onReset() : onChange(initialValue || '')
  }
}

export const getLozenge = (
  option: {
    label: string
    value: any
  },
  onChange: any,
  values: any,
  onReset?: any,
  initialValue?: any,
): React.ReactNode => {
  const onRemove = (lozengeValue: any) =>
    removeLozengeAndUpdateValue(lozengeValue, values, onChange, initialValue, onReset)

  return <FilterLozenge onRemove={onRemove} key={option.value} {...option} />
}

export const getLozengeOptions = (
  values: any,
  fieldData: any,
  options: any,
  labelPrefix?: string,
): Array<{ label: string; value: any }> => {
  return values.map((value: any) => {
    let option
    if (fieldData.type === FILTER_TYPE.SLIDER) {
      option = {
        label: options.valueFormatter ? options.valueFormatter(values[0]) : values[0],
        value: values[0],
      }
    } else {
      option = options.find((opt: any) => {
        let optionValue = opt.value
        if (typeof value === 'string') {
          optionValue = optionValue.toString()
        }

        return optionValue === value
      })
    }

    if (labelPrefix && option) {
      option = {
        ...option,
        label: `${labelPrefix}${option.label}`,
      }
    }

    return option
  })
}

export const getLozenges = (
  fieldData: any,
  onReset?: any,
  labelPrefix?: any,
  initialValue?: any,
): React.ReactNodeArray => {
  const { input, options } = fieldData
  const values =
    !input.value || input.value === '' || input.value === -1
      ? []
      : typeof input.value === 'string'
      ? input.value.split(',')
      : [input.value]
  const lozengeOptions = getLozengeOptions(values, fieldData, options, labelPrefix)

  return lozengeOptions
    .filter((option) => !!option)
    .map((option) => getLozenge(option, input.onChange, values, onReset, initialValue))
}

const LozengeGroup: React.FC<FilterLozengeProps> = ({ labelPrefix, onReset, initialValue, ...props }) => {
  const field = (fieldData: any) => {
    const lozenges = getLozenges(fieldData, onReset, labelPrefix, initialValue)

    return lozenges && lozenges.length ? (
      <div className={styles.lozenges} role="list">
        {lozenges}
      </div>
    ) : null
  }

  return <Field {...props} component={(fieldData: any) => field(fieldData)} format={setToString} />
}

export default LozengeGroup
